export default __webpack_public_path__ + "static/media/fellowship.3c06d095.png";